import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";
import { RecurringEmailRecipient } from "@/modules/emailManagement/features/RecurringEmailManagement/api/fetchRecurringEmailRecipients/types";

interface UnsubscribeRecipientModalProps {
  recipient: RecurringEmailRecipient | null;
  label: string;
  isSubmitting: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const UnsubscribeRecipientModal: React.FC<UnsubscribeRecipientModalProps> = ({
  recipient,
  label,
  isSubmitting,
  onConfirm,
  onClose,
}) => {
  return (
    <Modal
      isOpen={recipient !== null}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          right: "auto",
          bottom: "auto",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          width: "500px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Unsubscribe {recipient?.name}?
      </h3>
      <p className="mt-3 text-sm text-gray-600">
        {recipient?.name} at {recipient?.companyName} will stop receiving the{" "}
        {label}.
        <br />
        You can re-subscribe them from their Edit User page.
      </p>

      <div className="mt-6 flex justify-end space-x-3">
        <Button className="rounded-md" onClick={onClose} variant="outline">
          Cancel
        </Button>

        <Button
          className="rounded-md"
          disabled={isSubmitting}
          onClick={onConfirm}
          variant="default"
        >
          {isSubmitting ? "Unsubscribing..." : "Unsubscribe"}
        </Button>
      </div>
    </Modal>
  );
};

export default UnsubscribeRecipientModal;
